import {useRef} from 'react'
import {useSelector} from 'react-redux'
import InputGroup from 'react-bootstrap/InputGroup'
import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import {useState,useEffect} from 'react'
import useCurrencySettings from '../../hooks/useCurrencySettings'
import useStripePromise from '../../hooks/useStripeAccount'
import {envAwarePost} from '../../util/util'
import useCurrentUser from '../../hooks/useCurrentUser'
import { Elements, ElementsConsumer } from '@stripe/react-stripe-js'
import PurchaseModal from "./PurchaseModal"
import {
	useCreatePurchaseForm,
	useRemovePurchaseForm,
	usePurchaseItemForms
} from './hooks'
import Select from 'react-select'

const CustomPayment = ()=>{
	const [paymentTotal,setPaymentTotal] = useState('')
	const taxPercent = useSelector(state=>state.settings.app.tax_percent)
	const taxAmount = parseFloat(paymentTotal || 0)*taxPercent/100
	const grandTotal = parseFloat((parseFloat(paymentTotal || 0)+taxAmount).toFixed(2))
	const { acceptedCurrency: defaultAcceptedCurrency } = useCurrencySettings()
	const user = useCurrentUser()
	const isOwner = (
		(parseInt(user.gym_id) !== 0 && user.account_type==='gym') ||
		(parseInt(user.gym_id) === 0 && user.account_type==='trainer')
	)
	const stripeAccount = useSelector(state => state.users.current_user.trainer_stripe_account)
	const stripePromise = useStripePromise(stripeAccount)
	const [showPurchaseModal,setShowPurchaseModal] = useState(false)
	const {
		status:paymentFormsStatus,
		forms:paymentForms,
		allForms
	} = usePurchaseItemForms('custom_payment')

	const createPurchaseForm = useCreatePurchaseForm()
	const removePurchaseForm = useRemovePurchaseForm()

	const clientUserId = useSelector(
		state => state.users.current_user.user_id
	)
	const clientName = useSelector(
		state => state.users.current_user.user_name
	)
	const trainerId = useSelector(
		state => state.users.current_user.bio_data.user_trainer_id
	)

	const getPaymentIntent = () => {
		const payload = {
			action: 'getPaymentIntent',
			paymentAmount: grandTotal*100,
			clientEmail: clientUserId,
			trainer_id: trainerId,
			numSessions: 0,
			clientName: clientName,
			paymentType: "custom_payment",
			package_currency_id:defaultAcceptedCurrency.id,
			purchase_description:`Custom Payment (${grandTotal} ${defaultAcceptedCurrency.ISO})`
		}
		return envAwarePost("api/purchases/trainer_page/", payload)
	}

	const [clientSecret,setClientSecret] = useState(null)
	const [loadingCheckout,setLoadingCheckout] = useState(false)
	const timeoutRef = useRef()
	useEffect(async()=>{
		if(grandTotal===0||!Boolean(grandTotal)) return
		setLoadingCheckout(true)
		clearTimeout(timeoutRef.current)
		timeoutRef.current = setTimeout(async()=>{
			const res = await getPaymentIntent()
			if(res) setLoadingCheckout(false)
			setClientSecret(res.data)
		},500)
	},[grandTotal])

	return (
		isOwner
		//Owner UI
		? <div>
			<small>
				<i className="fa fa-info-circle mr-1"/>
				Clients will be prompted to fill out the selected forms when making a custom payment.
			</small>
			<div>
				<Select 
					onChange={(_,payload)=>{
						switch(payload.action){
							case 'select-option':
								createPurchaseForm({
									itemType:'custom_payment',
									formId:payload.option.value
								})
								break;
							case 'remove-value':
								removePurchaseForm({
									itemType:'custom_payment',
									formId:payload.removedValue.value
								})
								break;
						}
					}}
					value={
						paymentForms.map(
							form => ({
								value:form.form_id,
								label:form.form_title
							})
						)//end map
					}
					options={
						allForms.map(
							form => ({
								value:form.form_id,
								label:form.form_title
							})
						)//end map
					}//end options
					isMulti
				/>
			</div>
		</div>
		//client UI
		: <div>
			<div>
				<strong>Send custom payment to your trainer</strong>
				<InputGroup>
					<InputGroup.Prepend>
						<InputGroup.Text>
							{String.fromCharCode(defaultAcceptedCurrency.char_code)}
						</InputGroup.Text>
					</InputGroup.Prepend>
					<Form.Control 
						onChange={ e => { setPaymentTotal(e.target.value) } }
						placeholder={defaultAcceptedCurrency.ISO}
						value={paymentTotal}
					/>
				</InputGroup>
				<div>
					Tax: {String.fromCharCode(defaultAcceptedCurrency.char_code)}{taxAmount}
				</div>
				<div>
					Total: {String.fromCharCode(defaultAcceptedCurrency.char_code)}{grandTotal}
				</div>
				<Button
					disabled={loadingCheckout}
					onClick={()=>{ setShowPurchaseModal(true) }} 
					variant="outline-primary"
				>
					Send Payment {loadingCheckout&&<Spinner animation="border" size="sm"/>}
				</Button>
			</div>
			{(Boolean(stripePromise)&&Boolean(clientSecret))&&
				<Elements stripe={stripePromise} options={{
					clientSecret
				}}>
					<ElementsConsumer>
						{({ elements, stripe }) => (
							<PurchaseModal
								meta={{forms:paymentForms}}
								totalPurchase={grandTotal}
								totalSessions={0}
								paymentType={"custom"}
								show={showPurchaseModal}
								toggle={() => {
									setShowPurchaseModal(!showPurchaseModal)
								}}
								elements={elements}
								stripe={stripe}
								onSuccess={()=>{
									setPaymentTotal('')
								}}
							/>
						)}
					</ElementsConsumer>
				</Elements>
			}
		</div>
	)
}

export default CustomPayment